import { SettingConst } from '../../types';

/**
 * Experiment setting enabling domain stripping for web retailer and web brand absolute links
 */
export const ABSOLUTE_LINK_DOMAIN_STRIPPING_240201 =
  'ABSOLUTE_LINK_DOMAIN_STRIPPING_240201' as SettingConst<
    'ABSOLUTE_LINK_DOMAIN_STRIPPING_240201',
    boolean,
    'RETAILER' | 'MAKER'
  >;
